// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/facilityGroup_events.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FacilityGroup } from "./facilityGroup_pb.js";
import { file_core_v1_facilityGroup } from "./facilityGroup_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/facilityGroup_events.proto.
 */
export const file_core_v1_facilityGroup_events: GenFile = /*@__PURE__*/
  fileDesc("CiJjb3JlL3YxL2ZhY2lsaXR5R3JvdXBfZXZlbnRzLnByb3RvEgdjb3JlLnYxIsIBChJGYWNpbGl0eUdyb3VwRXZlbnQSNQoHY3JlYXRlZBgBIAEoCzIiLmNvcmUudjEuRmFjaWxpdHlHcm91cENyZWF0ZWRFdmVudEgAEjUKB3VwZGF0ZWQYAiABKAsyIi5jb3JlLnYxLkZhY2lsaXR5R3JvdXBVcGRhdGVkRXZlbnRIABI1CgdkZWxldGVkGAMgASgLMiIuY29yZS52MS5GYWNpbGl0eUdyb3VwRGVsZXRlZEV2ZW50SABCBwoFZXZlbnQiSwoZRmFjaWxpdHlHcm91cENyZWF0ZWRFdmVudBIuCg5mYWNpbGl0eV9ncm91cBgBIAEoCzIWLmNvcmUudjEuRmFjaWxpdHlHcm91cCKMAQoZRmFjaWxpdHlHcm91cFVwZGF0ZWRFdmVudBI3ChdwcmV2aW91c19mYWNpbGl0eV9ncm91cBgBIAEoCzIWLmNvcmUudjEuRmFjaWxpdHlHcm91cBI2ChZ1cGRhdGVkX2ZhY2lsaXR5X2dyb3VwGAIgASgLMhYuY29yZS52MS5GYWNpbGl0eUdyb3VwIksKGUZhY2lsaXR5R3JvdXBEZWxldGVkRXZlbnQSLgoOZmFjaWxpdHlfZ3JvdXAYASABKAsyFi5jb3JlLnYxLkZhY2lsaXR5R3JvdXBCLVorcGFja2FnZXMvYmFja2VuZC1tb2R1bGUtY29yZS9hcGkvdjE7Y29yZV92MWIIZWRpdGlvbnNw6Ac", [file_core_v1_facilityGroup, file_types]);

/**
 * @generated from message core.v1.FacilityGroupEvent
 */
export type FacilityGroupEvent = Message<"core.v1.FacilityGroupEvent"> & {
  /**
   * @generated from oneof core.v1.FacilityGroupEvent.event
   */
  event: {
    /**
     * @generated from field: core.v1.FacilityGroupCreatedEvent created = 1;
     */
    value: FacilityGroupCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: core.v1.FacilityGroupUpdatedEvent updated = 2;
     */
    value: FacilityGroupUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: core.v1.FacilityGroupDeletedEvent deleted = 3;
     */
    value: FacilityGroupDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message core.v1.FacilityGroupEvent.
 * Use `create(FacilityGroupEventSchema)` to create a new message.
 */
export const FacilityGroupEventSchema: GenMessage<FacilityGroupEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup_events, 0);

/**
 * @generated from message core.v1.FacilityGroupCreatedEvent
 */
export type FacilityGroupCreatedEvent = Message<"core.v1.FacilityGroupCreatedEvent"> & {
  /**
   * @generated from field: core.v1.FacilityGroup facility_group = 1;
   */
  facilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.FacilityGroupCreatedEvent.
 * Use `create(FacilityGroupCreatedEventSchema)` to create a new message.
 */
export const FacilityGroupCreatedEventSchema: GenMessage<FacilityGroupCreatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup_events, 1);

/**
 * @generated from message core.v1.FacilityGroupUpdatedEvent
 */
export type FacilityGroupUpdatedEvent = Message<"core.v1.FacilityGroupUpdatedEvent"> & {
  /**
   * @generated from field: core.v1.FacilityGroup previous_facility_group = 1;
   */
  previousFacilityGroup?: FacilityGroup;

  /**
   * @generated from field: core.v1.FacilityGroup updated_facility_group = 2;
   */
  updatedFacilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.FacilityGroupUpdatedEvent.
 * Use `create(FacilityGroupUpdatedEventSchema)` to create a new message.
 */
export const FacilityGroupUpdatedEventSchema: GenMessage<FacilityGroupUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup_events, 2);

/**
 * @generated from message core.v1.FacilityGroupDeletedEvent
 */
export type FacilityGroupDeletedEvent = Message<"core.v1.FacilityGroupDeletedEvent"> & {
  /**
   * @generated from field: core.v1.FacilityGroup facility_group = 1;
   */
  facilityGroup?: FacilityGroup;
};

/**
 * Describes the message core.v1.FacilityGroupDeletedEvent.
 * Use `create(FacilityGroupDeletedEventSchema)` to create a new message.
 */
export const FacilityGroupDeletedEventSchema: GenMessage<FacilityGroupDeletedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_facilityGroup_events, 3);

